import { useState } from 'react';
import translations from '../../../../../../../../translations';
import ConnectorDropdown from '../../../../../../../generic/ConnectorDropdown';
import FormGroup from '../../../../../../../generic/FormGroup';
import OpenApiPathDropdown from '../../../../../../../generic/OpenApiPathDropdown';
import Loader from '../../../../../../../loader/Loader';
import { usePageEditor } from '../../../../../PageEditorProvider';
import ConfigSection from '../../ConfigSection';
import { useNotificationDispatch } from '../../../../../../../notifications/NotificationProvider';
import { isNullOrEmpty } from '../../../../../../../../utils/guard';

interface Props {
    updateConnector: (connectorId: string | null) => void;
    updateResourcePath: (resourcePath: string) => void;
    updatePath: (path: string | null) => void;
    resourcePath: string | null;
    selectedConnectorId: string | null;
    selectedPath: string | null;
}

const FileDataSourceConfig = ({
    updateConnector,
    updateResourcePath,
    updatePath,
    resourcePath,
    selectedConnectorId,
    selectedPath,
}: Props) => {
    const { isLoading } = usePageEditor();
    const [isOpenApi, setIsOpenApi] = useState(false);

    const dispatchNotification = useNotificationDispatch();

    const onError = (message: unknown) => {
        dispatchNotification({
            type: 'notifyError',
            payload: { error: message },
        });
    };

    return (
        <ConfigSection dataTestId="file-data-source-config" title="Data source">
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <FormGroup
                        label={translations.PAGE_BUILDER_file_connector_id_label}
                        htmlFor="connector-dropdown"
                        isRequired
                        isValid={!isNullOrEmpty(selectedConnectorId)}
                        validationMessage={
                            translations.PAGE_BUILDER_field_is_required_validation_message
                        }
                        showValidation={true}
                    >
                        <ConnectorDropdown
                            selectedConnectorId={selectedConnectorId}
                            onChange={(e) => {
                                updatePath(null);
                                updateConnector(e?.value ?? null);
                            }}
                            onError={onError}
                            isOpenApi={setIsOpenApi}
                        />
                    </FormGroup>
                    {selectedConnectorId && isOpenApi && (
                        <FormGroup
                            label={translations.PAGE_BUILDER_file_path_label}
                            htmlFor="path-dropdown"
                        >
                            <OpenApiPathDropdown
                                selectedConnectorId={selectedConnectorId}
                                onChange={(e) => updatePath(e?.value ?? null)}
                                onError={onError}
                                selectedPath={selectedPath}
                            />
                        </FormGroup>
                    )}
                    {selectedConnectorId && (
                        <FormGroup
                            label={translations.PAGE_BUILDER_file_resource_path_label}
                            htmlFor="resource-path"
                        >
                            <input
                                className="form-control"
                                id="resource-path"
                                type="text"
                                value={resourcePath || ''}
                                onChange={({ target }) => updateResourcePath(target.value)}
                            />
                        </FormGroup>
                    )}
                </>
            )}
        </ConfigSection>
    );
};

export default FileDataSourceConfig;
